import classNames from 'classnames'
import { useEffect, useState } from 'react'

import style from '@/app/styles/layout.module.scss'
import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

export const Scroller = () => {
    const onClickScroller = () => window.scrollTo(0, 0)

    const [scrollPosition, setScrollPosition] = useState<number>(0)

    const handleScroll = () => {
        const position = window.scrollY
        setScrollPosition(position)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    return (
        <div
            className={classNames(style.scrollUpBtn, scrollPosition <= 500 && style.scrollUpBtnDisbled)}
            onClick={onClickScroller}
        >
            <div>
                <Icon iconName={EIcons.AROW} color='#fff' width='20' height='20' />
            </div>
        </div>
    )
}
